"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var extra_converter_1 = require("../extra-converter");
var ReversedProtocolConfigurationConverter_1 = require("../extra-converter/ReversedProtocolConfigurationConverter");
__export(require("./model-converters"));
__export(require("./enum-converter"));
__export(require("../extra-converter"));
exports.UartSettingsConverterInstance = new extra_converter_1.ReversedUartSettingsConverter();
exports.ProtocolConfigurationConverterInstance = new ReversedProtocolConfigurationConverter_1.ReversedProtocolConfigurationConverter();
